"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconMore = _interopRequireDefault(require("./IconMore"));
var IconMoreVertical = /*#__PURE__*/(0, _styledComponents.default)(_IconMore.default).withConfig({
  displayName: "IconMoreVertical",
  componentId: "c11n-8-107-0__sc-1hfgttx-0"
})(["transform:rotate(90deg);"]);
var _default = IconMoreVertical;
exports.default = _default;